import React from "react";
import { useTranslation } from "@helpers/translate";
import MultiplyIcon from "@assets/icons/MultiplyIcon";
import { blurOnEnter } from "../../utils/input";

/**
 * @param {object} props
 * @param {string} props.leverageDraft
 * @param {React.RefObject} props.leverageInputRef
 * @param {(event: React.ChangeEvent<HTMLInputElement>) => void} props.onLeverageInput
 * @param {(event: React.FocusEvent<HTMLInputElement>) => void} props.onLeverageFocus
 * @param {() => void} props.onLeverageBlur
 * @param {string} props.leverageFieldWidth
 */
export const LeverageInput = ({
  leverageDraft,
  leverageInputRef,
  onLeverageInput,
  onLeverageFocus,
  onLeverageBlur,
  leverageFieldWidth,
}) => {
  const { __ } = useTranslation();

  return (
    <div className="trade-form__leverage-value">
      <input
        ref={leverageInputRef}
        className="trade-form__field"
        value={leverageDraft}
        onChange={onLeverageInput}
        onFocus={onLeverageFocus}
        onBlur={onLeverageBlur}
        onKeyDown={blurOnEnter}
        style={{ width: leverageFieldWidth }}
        inputMode="numeric"
        aria-label={__("futures.leverage")}
        autoComplete="off"
      />
      <MultiplyIcon className="trade-form__multiply" size={15} color="#6E7784" />
    </div>
  );
};
